<template>
  <section
    class="plane-container"
    v-resize.initial:debounce="handleResize"
    :style="containerStyle"
  >
    <div
      ref="bgImgWrapper"
      class="plane__inner"
      :style="bgImgWrapperStyle"
      v-resize.initial:debounce="handleBgImageSrc"
      @mousemove="getCursorPosition($event)"
    >
      <!--      <div class="plane__logo">
        <img src="img/air_france_logo.png" alt="Air France logo" />
      </div>-->
      <img
        ref="bgImg"
        :style="bgImgStyle"
        class="plane__img"
        :src="bgImageSrc"
        alt=""
      />
    </div>
    <seat
      v-for="seat in seats"
      :title="seat.title"
      :key="seat.title"
      :styles="seat.style"
      :svg="seat.svg"
      :status="seat.status"
      :row="seat.row"
      :passenger="seat.passenger"
    >
    </seat>

    <div v-if="debug" class="coords">
      x: {{ cursor.x }}<br />
      y: {{ cursor.y }}<br />
      posX: {{ cursor.x / bgImgInitialSize.width }}<br />
      posY: {{ cursor.y / bgImgInitialSize.height }}
    </div>
  </section>
</template>

<script>
import resize from "vue-resize-directive"
import $ from "jquery"

import Seat from "./SeatV2"

export default {
  name: "Seats",
  directives: {
    resize
  },
  components: {
    Seat
  },
  props: {
    firstname: {
      type: String
    },
    invitations: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      bgImgInitialSize: {
        width: 2000,
        height: 1074
      },
      bgImgSize: {
        width: null,
        height: null,
        offset: {
          left: 0,
          top: 0
        },
        position: {
          top: 0
        },
        outerHeight: 0
      },
      bgImgScale: {
        x: 1,
        y: 1
      },
      bgImageSrc: "",
      bgImgStyle: {},
      bgImgWrapperStyle: {},
      containerStyle: {},
      seats: [
        {
          title: "seat-1",
          x: 0.437,
          y: 0.602,
          smallScreen: {
            x: 0.408,
            y: 0.622
          },
          style: {},
          status: "confirmed",
          passenger: null,
          row: 1
        },
        {
          title: "seat-2",
          x: 0.437,
          y: 0.403,
          smallScreen: {
            x: 0.408,
            y: 0.395
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-3",
          x: 0.53,
          y: 0.602,
          smallScreen: {
            x: 0.54,
            y: 0.622
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-4",
          x: 0.53,
          y: 0.403,
          smallScreen: {
            x: 0.54,
            y: 0.395
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-5",
          x: 0.627,
          y: 0.602,
          smallScreen: {
            x: 0.683,
            y: 0.622
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-6",
          x: 0.627,
          y: 0.403,
          smallScreen: {
            x: 0.683,
            y: 0.395
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        }
      ],
      debug: false,
      cursor: {
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    handleResize() {
      this.bgImgSize.width = $(this.$refs.bgImg).width()
      this.bgImgSize.height = $(this.$refs.bgImg).height()
      this.bgImgSize.offset.top = $(this.$refs.bgImg).offset().top
      this.bgImgSize.offset.left = $(this.$refs.bgImg).offset().left
    },
    handleBgImageSrc() {
      this.bgImageSrc =
        window.innerWidth <= 600 ? "img/minibus-sm.jpg" : "img/minibus.jpg"
    },
    getCursorPosition(evt) {
      if (!this.debug) return

      this.cursor = {
        x: Math.round(evt.clientX / this.bgImgScale.x),
        y: Math.round(
          evt.clientY / this.bgImgScale.y -
            this.bgImgSize.offset.top / this.bgImgScale.y
        )
      }
    }
  },
  watch: {
    bgImgSize: {
      handler(bgImg) {
        if (bgImg.height > $(window).height()) {
          this.bgImgStyle = { opacity: 1, position: "absolute", bottom: 0 }
          this.bgImgWrapperStyle = { height: "calc(100vh - 50px)" }
        } else {
          this.bgImgStyle = { opacity: 1 }
          this.bgImgWrapperStyle = { height: "auto" }
        }
        this.bgImgScale.x = bgImg.width / this.bgImgInitialSize.width
        this.bgImgScale.y = bgImg.height / this.bgImgInitialSize.height

        this.seats.forEach((seat, index) => {
          // const y = seat.y * bgImg.height /*+ (bgImg.offset.top - 50)*/

          const x =
            (window.innerWidth <= 600 ? seat.smallScreen.x : seat.x) *
            bgImg.width
          const bottom =
            (1 - (window.innerWidth <= 600 ? seat.smallScreen.y : seat.y)) *
            bgImg.height

          this.seats[index].style = {
            left: x + "px",
            bottom: bottom + "px"
          }
        })
      },
      deep: true
    },
    invitations: {
      handler(invitations) {
        invitations.forEach((invitation, index) => {
          let status = "empty"
          if (invitation.isAccepted) {
            status = "confirmed"
          } else if (invitation.createdAt) {
            status = "awaiting"
          }
          this.seats[index + 1].status = status
          this.seats[index + 1].passenger = invitation.recipientFirstname
        })
      },
      deep: true,
      immediate: true
    },
    firstname: {
      handler(firstname) {
        this.seats[0].passenger = firstname
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.plane-container {
  margin-top: 45px;
}

.plane__inner {
  margin: 0 auto;
  position: relative;
  background-color: whitesmoke;
}

.plane__img {
  display: block;
  opacity: 0;
  width: 100%;
  transition: opacity 0.3s;
}

.plane__logo {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 15%;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1;

  > img {
    display: block;
    width: 80%;
    max-width: 500px;
    max-height: 90%;
  }
}

.coords {
  position: absolute;
  top: 50px;
  left: 50px;
  padding: 5px 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
